import React from 'react';

import classes from './Avatar.module.css';

const Avatar = props => {
	return <div className={classes.Avatar} style={{ backgroundImage: `url(${props.imgUrl})` }} />;
};

export default Avatar;
